import { createSlice } from "@reduxjs/toolkit";

interface LogoutState {
  isLoggingOut: boolean;
  logoutCompleted: boolean;
}

const initialState: LogoutState = {
  isLoggingOut: false,
  logoutCompleted: false,
};

const logoutSlice = createSlice({
  name: "logout",
  initialState,
  reducers: {
    startLogout(state) {
      state.isLoggingOut = true;
      state.logoutCompleted = false;
    },
    completeLogout(state) {
      state.isLoggingOut = false;
      state.logoutCompleted = true;
    },
    resetLogout() {
      return initialState;
    },
  },
});

export const { startLogout, completeLogout, resetLogout } = logoutSlice.actions;
export default logoutSlice.reducer;
